export default {
  send: 'Stuur bericht',
  unread_delimiter: 'Ongelezen berichten'
};
